export type TEventTypes = 'regular' | 'global';

export const EVENT_TYPE_REGULAR = 'regular';
export const EVENT_TYPE_GLOBAL = 'global';

